import { Injectable, inject } from '@angular/core';
import { LogService } from '@viag/ngx-logger';

import { PromiseUtil } from '../utils/promise-util';

@Injectable({
  providedIn: 'root'
})
export class GpsService {
  private log = inject(LogService);

  askPermission(): void {
    this.getCoords()
      .then(_ => _) // value not needed
      .catch(_ => _); // just catch & forget
  }

  getCoords(): Promise<string> {
    return new Promise(resolve => {
      PromiseUtil
        .measureExecution(() => this.getLocation().then(resolve))
        .then(duration => {
          // TODO default log as info
          // BUT if more then 1 or 2 secs then log as warn
          this.log.warn(`GPS localization`, { duration });
        });
    });
  }

  private getLocation(): Promise<string> {
    return new Promise((resolve) => {

      if (!navigator.geolocation) {
        const errorReason = 'GPS_NOT_SUPPORTED';
        this.log.error(errorReason);
        resolve(errorReason);
        return;
      }

      navigator.geolocation.getCurrentPosition(
        position => {
          // Format [START-POSITION/END-POSITION]
          // LAT:46.9922744890821 LON:8.30748737769473/LAT:46.9919038439502 LON:8.3076002715196
          const gpsData = `LAT:${position.coords.latitude} LON:${position.coords.longitude}`;
          // TODO: Google Chrome unterstützt bald genauen oder ungefähren Standort, noch kein Standard
          // evtl. position.coords.accuracy mitliefern? 
          resolve(gpsData);
          return;
        },
        error => {
          const errorReason = this.locationError(error);
          if (errorReason.error) {
            this.log.error(errorReason.msg, error);
          } else {
            this.log.warn(errorReason.msg, error);
          }
          resolve(errorReason.msg);
          return;
        },
        {
          enableHighAccuracy: true, // genauer aber langsamer
          maximumAge: 30000, // max. 30 sek. vom cache
          // Bei Android-Geräten => Einstellungen => Standort => Google Standortgenuigkeit => Aus
          // und Timeout ist Standardmässig auf Infitiy dann wir das Promise nie aufgelöst bzw. keine Callbacks werden aufgerufen
          timeout: 10000, // nach ms Timeout (min. 0 sonst nie eine Rückmeldung!)
        },
      );

    });

  }

  private locationError(error: any) {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        return { msg: 'GPS_PERMISSION_DENIED', error: false };
      case error.POSITION_UNAVAILABLE:
        return { msg: 'GPS_POSITION_UNAVAILABLE', error: false };
      case error.TIMEOUT:
        return { msg: 'GPS_TIMEOUT_EXPIRED', error: false };
      case error.UNKNOWN_ERROR:
        return { msg: 'GPS_UNKNOWN_ERROR', error: true };
      default:
        return { msg: 'GPS_UNKNOWN_CODE', error: true };
    }
  }

}
